/**
 * LaunchBanner — banner globale "Nuova versione · lancio 1 Luglio 2026".
 *
 * Mostrato in cima a tutte le pagine della variant ristorazione.
 * Dismissible (salvato in localStorage), riappare se cambio versione.
 *
 * Iter R52.15.
 */
import { useState } from "react";
import { Rocket, X } from "lucide-react";

const STORAGE_KEY = "ristorazione_launch_banner_dismissed_v1";

export default function LaunchBanner() {
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === "1"; } catch { return false; }
  });
  if (hidden) return null;

  const dismiss = () => {
    try { localStorage.setItem(STORAGE_KEY, "1"); } catch { /* ignore */ }
    setHidden(true);
  };

  return (
    <div
      data-testid="launch-banner"
      className="relative w-full bg-gradient-to-r from-amber-400 via-orange-400 to-rose-400 text-slate-900 px-3 py-2 text-center shadow-sm"
    >
      <div className="max-w-md mx-auto flex items-center justify-center gap-2 pr-7">
        <Rocket className="w-4 h-4 shrink-0" />
        <p className="text-[11px] sm:text-xs font-bold leading-tight">
          Anteprima · <span className="font-extrabold">Lancio ufficiale 1 Luglio 2026</span>
        </p>
      </div>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Chiudi banner"
        data-testid="launch-banner-close"
        className="absolute right-1.5 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-white/30 hover:bg-white/50 flex items-center justify-center text-slate-900"
      >
        <X className="w-3 h-3" />
      </button>
    </div>
  );
}
